// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-base {
  margin-top: var(--base-sizes-4);
  margin-bottom: var(--base-sizes-4);
  padding: var(--base-sizes-8);
  background: #fff;
  border-radius: 4px;
  flex-direction: column;
  width: 500px;
  display: flex;
  position: relative;
  box-shadow: 0 4px 15px #0000001a;
}

.dialog-base.dialog-base--cap-to-window-height {
  max-height: 100%;
  overflow: auto;
}

.dialog-base__btn-cancel {
  position: absolute;
  top: 16px;
  right: 20px;
}

.dialog-base__header {
  font-size: 1rem;
  line-height: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/packages/frontend-libs/ui-components/src/DialogBase/DialogBase.css","webpack://./packages/frontend-libs/ui-components/src/DialogBase/DialogBase.css"],"names":[],"mappings":"AADA;ECEE,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".dialog-base {\n\n  display: flex;\n\n  flex-direction: column;\n\n  margin-top: var(--base-sizes-4);\n\n  margin-bottom: var(--base-sizes-4);\n\n  padding: var(--base-sizes-8);\n\n  width: 500px;\n  background: #ffffff;\n  border-radius: 4px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n  .dialog-base.dialog-base--cap-to-window-height {\n\n  max-height: 100%;\n    /* dialog children should handle scroll themselves properly. But as a fallback, if the content does not fit,\n     we allow scroll to appear on the dialog itself. It would be ugly, but at least all content will be\n     accessible.*/\n    overflow: auto;\n}\n\n.dialog-base__btn-cancel {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n}\n\n.dialog-base__header {\n\n  font-size: 1rem;\n\n  line-height: 1.5rem;\n}\n",".dialog-base {\n  margin-top: var(--base-sizes-4);\n  margin-bottom: var(--base-sizes-4);\n  padding: var(--base-sizes-8);\n  background: #fff;\n  border-radius: 4px;\n  flex-direction: column;\n  width: 500px;\n  display: flex;\n  position: relative;\n  box-shadow: 0 4px 15px #0000001a;\n}\n\n.dialog-base.dialog-base--cap-to-window-height {\n  max-height: 100%;\n  overflow: auto;\n}\n\n.dialog-base__btn-cancel {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n}\n\n.dialog-base__header {\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
